import { render, staticRenderFns } from "./DropdownArrowSvg.vue?vue&type=template&id=06216c55"
import script from "./DropdownArrowSvg.vue?vue&type=script&lang=js"
export * from "./DropdownArrowSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports